import React from 'react'
import LayoutContainer from "../../../layout/layout-container/index";
import DetailField from '../user/detail-field'

const PpcLoadDetails = ({load}) => {
  return (
    <LayoutContainer>
      <div className="mg-bottom-10">
        <DetailField label="User name">
          {load.attributes['first-name']} {load.attributes['last-name']}
        </DetailField>
        <DetailField label="PPC account number">
          {load.attributes['account-number']}
        </DetailField>
      </div>
      <div className="mg-bottom-20">
        <DetailField label="Available points balance">
          {load.attributes['available-points-balance']}
        </DetailField>
      </div>
    </LayoutContainer>
  )
};

export default PpcLoadDetails


// WEBPACK FOOTER //
// ./src/components/admin/ppc/load-manual/ppc-load-details.jsx